export default __webpack_public_path__ + "static/media/emailWhite.94f0c077.svg";